<nav
  [class.compound-top-navbar]="!showMobileNavVersion"
  [class.compound-top-navbar-mobile]="showMobileNavVersion"
  [class.navbar-fixed-height]="isVerticalNavigationEnabled()"
  [attr.aria-label]="'top_level_navbar_label' | translate"
>
  @if (isVerticalNavigationEnabled()) {
    <div class="d-flex align-items-center justify-content-between gap-2 vertical-nav-container">
      <ng-container
        *ngTemplateOutlet="showMobileNavVersion ? verticalNavMobileVersion : verticalNavDesktopVersion"
      ></ng-container>
    </div>
  } @else {
    <div class="container-fluid">
      <ng-container *ngTemplateOutlet="showMobileNavVersion ? mobileVersion : desktopVersion"></ng-container>
    </div>
  }
</nav>

<ng-template #launcherModal let-modal>
  <app-switcher-modal></app-switcher-modal>
</ng-template>

<ng-template #mobileNavModal let-modal>
  <app-mobile-top-navbar-menu-modal [modal]="modal"></app-mobile-top-navbar-menu-modal>
</ng-template>

<ng-template #topNavLogo>
  @if (!isVerticalNavigationEnabled()) {
    <ds-link
      [rtLink]="logoUrl$ | async"
      queryParamsHandling="preserve"
      [standalone]="true"
      data-test-id="top-nav-logo-link"
      class="top-nav-logo-link"
    >
      <img
        class="top-navbar-logo-img"
        src="/static/assets/images/2025-LevelAccess_Logo-Horizontal_White-RGB.png"
        srcset="
          /static/assets/images/2025-LevelAccess_Logo-Horizontal_White-RGB.png    1x,
          /static/assets/images/2025-LevelAccess_Logo-Horizontal_White-RGB@2x.png 2x
        "
        alt="{{ 'level_access_home' | translate }}"
      />
    </ds-link>
  }
</ng-template>

<ng-template #desktopVersion>
  <div class="compound-top-navbar-left">
    <ng-container *ngTemplateOutlet="topNavLogo"></ng-container>
    @if (hasAccessToLauncher && !isVerticalNavigationEnabled()) {
      <button
        ds-button
        id="top-nav-switcher-button"
        class="top-nav-switcher-button"
        data-test-id="top-nav-switcher-button"
        [attr.aria-label]="'switcher' | translate"
        [ds-tooltip]="'switcher' | translate"
        [tooltipPlacement]="DsTooltipPosition.bottom"
        (click)="openLauncher()"
      >
        <ds-icon [icon]="Icons.ListUl" [iconStyle]="IconStyles.Solid" class="top-nav-switcher-icon"></ds-icon>
      </button>
    }

    @if (hasAccessToLauncher === false) {
      <top-navbar-control-hub-dropdown />
    }

    <ds-breadcrumb
      [breadcrumbs]="this.breadcrumbs$ | async"
      [dividerIcon]="Icons.ChevronRight"
      [lastBold]="true"
      [color]="DsLinkColor.White"
      [maxCharacters]="breadcrumbsMaxCharacters$ | async"
      class="p-0"
    />
  </div>

  <div class="compound-top-navbar-right">
    @if (showAiChatButton$ | async) {
      <app-ai-chat-button *appHasPermissions="RequiredSecurities.AI_CHAT_Create_DP"></app-ai-chat-button>
    }

    @if (hasAccessToLauncher) {
      <top-navbar-control-hub-dropdown />
    }

    @if (academyNavigationItem$ | async; as academy) {
      @if (academy.isAvailable) {
        <button
          ds-button
          [variant]="DsButtonVariants.microAction"
          [color]="DsButtonColor.White"
          [microActionIcon]="academy.iconName"
          role="link"
          class="academy-btn"
          (click)="academy.onClick()"
          data-test-id="top-nav-academy-link"
        >
          {{ 'academy' | translate }}
        </button>
      }
    }

    @if (hasAccessToNotifications$ | async) {
      <top-nav-notifications />
    }

    @if (navSupportPortalUxEnabled$ | async) {
      @if (helpNavigationItem$ | async; as helpNavigationItem) {
        <ds-dropdown
          class="top-nav-help"
          ds-tooltip="{{ helpNavigationItem.label | translate }}"
          [tooltipPlacement]="DsTooltipPosition.bottom"
        >
          <ds-dropdown-toggle
            [icon]="helpNavigationItem.iconName"
            [variant]="DsButtonVariants.microAction"
            [ariaLabel]="helpNavigationItem.label | translate"
          >
          </ds-dropdown-toggle>
          <div ds-dropdown-menu>
            @for (helpMenuItem of helpNavigationItem.children; track helpMenuItem.id) {
              <ds-dropdown-item
                [icon]="helpMenuItem.iconName"
                [href]="helpMenuItem.externalLinkFn(externalLinkService)"
                [label]="helpMenuItem.label | translate"
                [value]="helpMenuItem.id"
              >
              </ds-dropdown-item>
            }
          </div>
        </ds-dropdown>
      }
    } @else {
      @if (oldHelpNavigationItem$ | async; as oldHelpNavigationItem) {
        <ds-dropdown
          class="top-nav-old-help"
          ds-tooltip="{{ oldHelpNavigationItem.label | translate }}"
          [tooltipPlacement]="DsTooltipPosition.bottom"
        >
          <ds-dropdown-toggle
            [icon]="oldHelpNavigationItem.iconName"
            [variant]="DsButtonVariants.microAction"
            [ariaLabel]="oldHelpNavigationItem.label | translate"
          >
          </ds-dropdown-toggle>
          <div ds-dropdown-menu>
            @for (helpMenuItem of oldHelpNavigationItem.children; track helpMenuItem.id) {
              <ds-dropdown-item
                [icon]="helpMenuItem.iconName"
                [href]="helpMenuItem.externalLinkFn(externalLinkService)"
                [label]="helpMenuItem.label | translate"
                [value]="helpMenuItem.id"
              >
              </ds-dropdown-item>
            }
          </div>
        </ds-dropdown>
      }
    }

    <ng-template #oldHelp>
      @if (oldHelpNavigationItem$ | async; as oldHelpNavigationItem) {
        <ds-dropdown
          class="top-nav-old-help"
          ds-tooltip="{{ oldHelpNavigationItem.label | translate }}"
          [tooltipPlacement]="DsTooltipPosition.bottom"
        >
          <ds-dropdown-toggle
            [icon]="oldHelpNavigationItem.iconName"
            [variant]="DsButtonVariants.microAction"
            [ariaLabel]="oldHelpNavigationItem.label | translate"
          >
          </ds-dropdown-toggle>
          <div ds-dropdown-menu>
            @for (helpMenuItem of oldHelpNavigationItem.children; track helpMenuItem.id) {
              <ds-dropdown-item
                [icon]="helpMenuItem.iconName"
                [href]="helpMenuItem.externalLinkFn(externalLinkService)"
                [label]="helpMenuItem.label | translate"
                [value]="helpMenuItem.id"
              >
              </ds-dropdown-item>
            }
          </div>
        </ds-dropdown>
      }
    </ng-template>

    <ng-container *featureFlag="FeatureFlagCollection.navSupportPortalUx">
      @if (serviceRequestNavigationItem$ | async; as serviceRequestNavigationItem) {
        <ds-dropdown
          class="top-nav-service"
          ds-tooltip="{{ serviceRequestNavigationItem.label | translate }}"
          [tooltipPlacement]="DsTooltipPosition.bottom"
        >
          <ds-dropdown-toggle
            [icon]="serviceRequestNavigationItem.iconName"
            [variant]="DsButtonVariants.microAction"
            [ariaLabel]="serviceRequestNavigationItem.label | translate"
          >
          </ds-dropdown-toggle>
          <div ds-dropdown-menu>
            @for (serviceRequestMenuItem of serviceRequestNavigationItem.children; track serviceRequestMenuItem.id) {
              @if (serviceRequestMenuItem.isAvailable) {
                <ds-dropdown-item
                  [icon]="serviceRequestMenuItem.iconName"
                  [href]="navMenuItemLink(serviceRequestMenuItem)"
                  [label]="serviceRequestMenuItem.label | translate"
                  [value]="serviceRequestMenuItem.id"
                >
                </ds-dropdown-item>
              }
            }
          </div>
        </ds-dropdown>
      }
    </ng-container>

    <top-navbar-profile-dropdown />
    @if (navSwitchOptionVisible()) {
      <app-new-nav-toggle />
    }
  </div>
</ng-template>

<ng-template #verticalNavDesktopVersion>
  <div class="d-flex align-items-center gap-3">
    <ds-breadcrumb
      [breadcrumbs]="this.breadcrumbs$ | async"
      [dividerIcon]="Icons.ChevronRight"
      [lastBold]="true"
      [color]="DsLinkColor.White"
      [maxCharacters]="breadcrumbsMaxCharacters$ | async"
      class="p-0"
    />
  </div>

  <div class="d-flex align-items-center gap-3">
    @if (showAiChatButton$ | async) {
      <app-ai-chat-button
        *appHasPermissions="RequiredSecurities.AI_CHAT_Create_DP"
        [variant]="DsButtonVariants.tertiary"
      ></app-ai-chat-button>
    }

    <top-navbar-profile-dropdown />
    @if (navSwitchOptionVisible()) {
      <app-new-nav-toggle />
    }
  </div>
</ng-template>

<ng-template #mobileVersion>
  <button
    ds-button
    [variant]="DsButtonVariants.microActionHorizontalLayout"
    [microActionIcon]="Icons.Grid"
    [color]="DsButtonColor.White"
    (click)="openMobileMenu()"
    data-test-id="open-mobile-menu-btn"
  >
    {{ 'menu' | translate }}
  </button>
  @if (showAiChatButtonMobile$ | async) {
    <app-ai-chat-button
      class="mobile-ai-chat-button"
      *appHasPermissions="RequiredSecurities.AI_CHAT_Create_DP"
    ></app-ai-chat-button>
  }
  <div class="top-nav-logo mobile-top-nav-logo">
    <ng-container *ngTemplateOutlet="topNavLogo"></ng-container>
  </div>
</ng-template>

<ng-template #verticalNavMobileVersion>
  <div class="d-flex align-items-center gap-2 overflow-hidden">
    @if (hasAccessToLauncher) {
      <button
        ds-button
        class="switcher-button"
        id="top-nav-switcher-button"
        data-test-id="top-nav-switcher-button"
        [attr.aria-label]="'switcher' | translate"
        [ds-tooltip]="'switcher' | translate"
        [tooltipPlacement]="DsTooltipPosition.right"
        [variant]="DsButtonVariants.primary"
        [icon]="Icons.ListTree"
        [isIconOnly]="true"
        (click)="openLauncher()"
      ></button>
    }
    <span class="context-label text-truncate" data-test-id="context-label">{{ currentContextItem()?.label }}</span>
  </div>

  <div class="d-flex align-items-center gap-2">
    @if (showAiChatButton$ | async) {
      <app-ai-chat-button
        *appHasPermissions="RequiredSecurities.AI_CHAT_Create_DP"
        [variant]="DsButtonVariants.tertiary"
        [isIconOnly]="true"
      ></app-ai-chat-button>
    }

    <button
      ds-button
      [isIconOnly]="true"
      [variant]="DsButtonVariants.secondary"
      [borderColors]="DsButtonBorderColors.none"
      [icon]="Icons.Bars"
      [color]="DsButtonColor.White"
      [attr.aria-label]="'menu' | translate"
      [ds-tooltip]="'menu' | translate"
      [tooltipPlacement]="DsTooltipPosition.bottom"
      (click)="openVerticalNavigationMenu()"
      data-test-id="open-vertical-navigation-menu-btn"
      class="menu-button"
    ></button>
  </div>
</ng-template>
